import { DOMAIN } from "../../../../var_env."
import { RequestResponsePattern } from "../../../../types/Request"
import { postApi } from "../../../../utils/requestApi"
import { setRequestSaveData, setRequestSaveLoading } from "../Reducers/LinksTutoriaisReducer"

export default async function saveOrdem(dispatch: Function, data: { idUsuario: number, ordens: { id: number, ordem: number }[] }) {
    try {
        dispatch(setRequestSaveLoading())
        const response: RequestResponsePattern<any> = await postApi({
            endpoint: `${DOMAIN}/LinksTutoriais/lista/ordem`,
            data,
        })
        if (response && !response.flagErro) {
            dispatch(setRequestSaveData(response))
        } else throw new Error(response?.listaMensagens?.[0] ?? 'Erro na requisição')
    } catch (error: any) {
        console.log(error)
    }
}
